import {
  Building2,
  Clock,
  CreditCard,
  FileText,
  Info,
  LayoutTemplate,
  Link,
  Mail,
  MapPin,
  Merge,
  MessageSquare,
  PenLine,
  Pill,
  Settings,
  Smartphone,
  Syringe,
  Users,
} from "lucide-react";

import { pathGenerators } from "utils/routes";
import { TENANT_TYPES } from "utils/tenantAccess";

export const SETTINGS_MENU_ITEMS = [
  {
    label: "Practice Details",
    to: pathGenerators.settings.practiceDetails(),
    Icon: Building2,
  },
  {
    label: "Locations",
    to: pathGenerators.settings.locations(),
    Icon: MapPin,
  },
  {
    label: "User Management",
    to: pathGenerators.settings.userDetails(),
    Icon: Users,
  },
  {
    label: "Services Details",
    to: pathGenerators.settings.serviceDetails(),
    Icon: Info,
  },
  {
    label: "Drugs File",
    to: pathGenerators.settings.drugsFile(),
    Icon: Pill,
    tenantTypes: [TENANT_TYPES.GP],
  },
  {
    label: "Document Types",
    to: pathGenerators.settings.documentTypes(),
    Icon: FileText,
  },
  {
    label: "Vaccines",
    to: pathGenerators.settings.vaccines(),
    Icon: Syringe,
    tenantTypes: [TENANT_TYPES.GP],
  },
  {
    label: "Practice Hours",
    to: pathGenerators.settings.practiceHours(),
    Icon: Clock,
  },
  {
    label: "Healthlink",
    to: pathGenerators.settings.healthlink(),
    Icon: Link,
    tenantTypes: [TENANT_TYPES.GP],
  },
  {
    label: "Headers & footers",
    to: pathGenerators.settings.headersFooters(),
    Icon: FileText,
  },
  {
    label: "Mobile App",
    to: pathGenerators.settings.mobileApp(),
    Icon: Smartphone,
  },
  {
    label: "Practice Settings",
    to: pathGenerators.settings.practiceSettings(),
    Icon: Settings,
  },
  {
    label: "Payments",
    to: pathGenerators.settings.paymentsDetails(),
    Icon: CreditCard,
  },
  {
    label: "SMS Templates",
    to: pathGenerators.settings.smsSettings(),
    Icon: MessageSquare,
  },
  {
    label: "Consultation templates",
    to: pathGenerators.settings.consultationTemplates(),
    Icon: LayoutTemplate,
  },
  {
    label: "Letter templates",
    to: pathGenerators.settings.letterTemplates(),
    Icon: PenLine,
  },
  {
    label: "Email Templates",
    to: pathGenerators.settings.emailTemplates(),
    Icon: Mail,
  },
  {
    label: "Merge Patient Records",
    to: pathGenerators.settings.mergePatients(),
    Icon: Merge,
  },
];
